import type { Tone } from '../../ui/tone';

/**
 * The four customer appointment states in the shared vocabulary, rather than four hand-picked
 * palettes. Shared by the appointment card and the case header's next meeting.
 *
 * "Requested" is `warning` and not `neutral` on purpose: it is the one state where the customer is
 * still waiting to hear back, and it has to stand out from the confirmed rows around it.
 */
export const APPOINTMENT_STATUS_TONES: Record<string, Tone> = {
    Requested: 'warning',
    Confirmed: 'positive',
    Completed: 'neutral',
    Cancelled: 'critical'
};
